// Content of the native legal pages (mentions légales, conditions générales).
export const ASSO = {
  name: "LGTDZ",
  form: "Association déclarée (loi 1901)",
  rna: "W691107205",
  siren: "923 200 703",
  siret: "923 200 703 00018",
  address: "32 rue de la Glacière, 69600 Oullins-Pierre-Bénite, France",
  director: "Alpha Diallo",
  email: "alpha@lgtdz.com",
  registry: "https://annuaire-entreprises.data.gouv.fr/entreprise/lgtdz-923200703",
};

const UPDATED = "4 novembre 2026";

export const LEGAL_PAGES = {
  "mentions-legales": {
    top: "Mentions",
    bottom: "légales",
    intro: "Qui édite LEGROSTASDEZIK, qui l'héberge, et comment nous joindre.",
    updated: UPDATED,
    sections: [
      {
        title: "Éditeur du site",
        lines: [
          `${ASSO.name} — ${ASSO.form}`,
          `RNA : ${ASSO.rna} · SIREN : ${ASSO.siren} · SIRET : ${ASSO.siret}`,
          `Siège : ${ASSO.address}`,
          { label: "Contact", email: ASSO.email },
          { label: "Fiche officielle de l'association", href: ASSO.registry },
        ],
      },
      { title: "Directeur de la publication", lines: [ASSO.director] },
      {
        title: "Hébergement",
        lines: ["Le site est hébergé par Emergent Labs, Inc. (emergent.sh).", "255 California Street, Suite 550, San Francisco, CA 94111, États-Unis", { label: "Contact", email: "support@emergent.sh" }],
      },
      {
        title: "Propriété intellectuelle",
        lines: [
          "Les textes, logos, visuels et émissions publiés sur ce site appartiennent à LGTDZ ou à leurs auteurs respectifs. Toute reproduction sans autorisation est interdite.",
          "Les pochettes, photos d'artistes et vidéos restent la propriété de leurs ayants droit ; elles sont utilisées à des fins d'information et de promotion. Un ayant droit qui souhaite un retrait peut nous écrire.",
        ],
      },
      {
        title: "Données personnelles",
        lines: [
          "Les données collectées via les formulaires (contact, newsletter, alertes concerts, dons) servent uniquement à LGTDZ et ne sont jamais revendues.",
          "Conformément au RGPD, tu peux demander l'accès, la rectification ou la suppression de tes données en écrivant à l'adresse de contact. Le détail figure dans les conditions générales.",
        ],
      },
    ],
  },
  "conditions-generales": {
    top: "Conditions",
    bottom: "générales",
    intro: "Les règles d'utilisation du site, de la radio, des dons et de tes données.",
    updated: UPDATED,
    sections: [
      {
        title: "Objet",
        lines: [
          `Ces conditions encadrent l'utilisation du site LEGROSTASDEZIK, édité par l'association ${ASSO.name}. Naviguer sur le site vaut acceptation de ces conditions.`,
        ],
      },
      {
        title: "Services proposés",
        lines: [
          "Le site propose gratuitement : une radio en continu, un agenda de concerts, un magazine, des podcasts, une carte des lieux et des fiches artistes.",
          "Les dates, horaires, prix et adresses de l'agenda et de la carte sont donnés à titre indicatif : vérifie toujours auprès de l'organisateur ou du lieu. La billetterie est assurée par des sites tiers, sous leurs propres conditions.",
        ],
      },
      {
        title: "Dons et abonnements de soutien",
        lines: [
          "Les dons ponctuels et mensuels sont des soutiens volontaires à l'association ; ils ne donnent pas droit à une contrepartie commerciale.",
          "Les paiements sont traités par Stripe (carte bancaire) ou PayPal. LGTDZ ne reçoit ni ne conserve tes coordonnées bancaires.",
          "Un don mensuel peut être arrêté à tout moment sur simple demande à l'adresse de contact.",
        ],
      },
      {
        title: "Données collectées",
        lines: [
          "Formulaire de contact : nom, e-mail et message, pour te répondre.",
          "Newsletter et alertes concerts : e-mail et villes choisies, pour t'envoyer les nouvelles dates. Chaque e-mail contient un lien de désinscription.",
          "Dons : nom, e-mail et montant, pour t'envoyer un reçu et tenir la comptabilité de l'association.",
          "Favoris de la radio : enregistrés uniquement dans ton navigateur, sauf si tu choisis de partager ta liste par un lien.",
          "Ces données sont conservées tant que tu restes abonné ou pendant la durée légale pour les dons.",
        ],
      },
      {
        title: "Tes droits",
        lines: [
          "Tu peux demander l'accès, la rectification, la suppression ou la portabilité de tes données, et t'opposer à leur utilisation.",
          { label: "Écris-nous", email: ASSO.email },
          "Tu peux aussi saisir la CNIL (cnil.fr).",
        ],
      },
      {
        title: "Cookies et services tiers",
        lines: [
          "Le site utilise un outil de mesure d'audience et le stockage de ton navigateur (favoris, préférences).",
          "Certains contenus viennent de services tiers (YouTube, Mixcloud, Spotify, RadioKing, OpenStreetMap) qui peuvent déposer leurs propres cookies lorsque tu les lis ou les affiches.",
        ],
      },
      {
        title: "Responsabilité",
        lines: [
          "LGTDZ fait de son mieux pour garder le site disponible et à jour, mais ne peut garantir l'absence d'erreurs ou d'interruptions. Les liens vers d'autres sites n'engagent pas LGTDZ.",
        ],
      },
      { title: "Droit applicable", lines: ["Ces conditions sont soumises au droit français."] },
    ],
  },
};
